import { Col, Row } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import TrackClick from '../../components/Onetrack/TrackClick';
import { useRegionData } from '../../components/RegionSelect';
import { Region } from '../../components/RegionSelect/interface';
import fallback from '../../utils/fallback';
import { useLocale } from '../../utils/i18n';
import RoundButton from './Button';
import { useContact } from './context';
import styles from './index.module.less';

const ContactMeta: React.FC = () => {
  const { values, category, type } = useContact();
  const regionData = useRegionData();
  const [locale] = useLocale();
  const history = useHistory();

  const { regionCode, requestCategoryId, requestTypeId } = values;

  const regions = React.useMemo(
    () =>
      Object.keys(regionData)
        .reduce<Region[]>((acc, key) => [...acc, ...regionData[key]], [])
        .reduce<Record<string, string>>(
          (acc, region) => ({ ...acc, [region.B]: region.C }),
          {}
        ),
    [regionData]
  );

  const handleChange = React.useCallback(() => {
    const params = new URLSearchParams(history.location.search);
    params.delete('requestCategoryId');
    params.delete('requestTypeId');
    history.push({
      pathname: '/contact/category',
      search: `?${params}`,
    });
  }, [history]);

  return (
    <div className={styles.meta}>
      <div className={styles.title}>
        <FormattedMessage id="Contact.Meta.Title" />
      </div>
      <div className={styles.subTitle}>
        <FormattedMessage id="Contact.Meta.Subtitle" />
      </div>
      {regionCode && requestCategoryId && (
        <>
          <div className={styles.divider} />
          <Row>
            <Col xs={24} sm={0}>
              <div>
                <div>
                  <div className={classNames(styles.field, styles.label)}>
                    <FormattedMessage id="Contact.Field.Region" />
                  </div>
                  <div className={styles.field}>{regions[regionCode]}</div>
                </div>
                <div>
                  <div className={classNames(styles.field, styles.label)}>
                    <FormattedMessage id="Contact.Field.Category" />
                  </div>
                  <div className={styles.field}>
                    {fallback(category, (items) => {
                      const finded = items.find(
                        (item) => item.requestCategoryId === requestCategoryId
                      );
                      if (!finded) {
                        return null;
                      }
                      return <>{finded.resource.locales[locale].name}</>;
                    })}
                    {requestTypeId &&
                      fallback(type, (items) => {
                        const finded = items.find(
                          (item) => item.requestTypeId === requestTypeId
                        );
                        if (!finded) {
                          return null;
                        }
                        return (
                          <span>
                            {' '}
                            &gt; {finded.resource.locales[locale].name}
                          </span>
                        );
                      })}
                  </div>
                </div>
                <TrackClick tip="71.6.0.1.2163">
                  <RoundButton
                    className={styles.change}
                    block
                    onClick={handleChange}
                  >
                    <FormattedMessage id="Contact.Button.Change" />
                  </RoundButton>
                </TrackClick>
              </div>
            </Col>
            <Col xs={0} sm={24}>
              <div style={{ display: 'flex' }}>
                <div className={styles.label}>
                  <div className={styles.field}>
                    <FormattedMessage id="Contact.Field.Region" />
                  </div>
                  <div className={styles.field}>
                    <FormattedMessage id="Contact.Field.Category" />
                  </div>
                </div>
                <div className={styles.value}>
                  <div className={styles.field}>{regions[regionCode]}</div>
                  <div className={styles.field}>
                    {fallback(category, (items) => {
                      const finded = items.find(
                        (item) => item.requestCategoryId === requestCategoryId
                      );
                      if (!finded) {
                        return null;
                      }
                      return <>{finded.resource.locales[locale].name}</>;
                    })}
                    {requestTypeId &&
                      fallback(type, (items) => {
                        const finded = items.find(
                          (item) => item.requestTypeId === requestTypeId
                        );
                        if (!finded) {
                          return null;
                        }
                        return (
                          <span>
                            {' '}
                            &gt; {finded.resource.locales[locale].name}
                          </span>
                        );
                      })}
                  </div>
                </div>
                <div className={styles.action}>
                  <RoundButton className={styles.change} onClick={handleChange}>
                    <FormattedMessage id="Contact.Button.Change" />
                  </RoundButton>
                </div>
              </div>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default ContactMeta;
